import { render } from "./SliderCampaigns.vue?vue&type=template&id=e87df558&scoped=true"
import script from "./SliderCampaigns.vue?vue&type=script&lang=js"
export * from "./SliderCampaigns.vue?vue&type=script&lang=js"

import "./SliderCampaigns.vue?vue&type=style&index=0&id=e87df558&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e87df558"

export default script